import { ButtonBase } from '@farmersdog/corgi-x';
import classNames from 'classnames';
import styles from './CategoryButton.module.css';
import { ExtendedText } from 'src/pages/HomepageRedesign/components';

interface CategoryButtonProps extends React.ComponentProps<typeof ButtonBase> {
  isActive: boolean;
  children: React.ReactNode;
}

export const CategoryButton = ({
  isActive,
  children,
  className,
  ...restProps
}: CategoryButtonProps) => {
  const buttonClass = classNames(styles.button, className, {
    [styles.active]: isActive,
  });

  return (
    <ButtonBase {...restProps} className={buttonClass}>
      <ExtendedText
        bold
        color="Kale3"
        variant="heading-12"
        className={styles.text}
      >
        {children}
      </ExtendedText>
    </ButtonBase>
  );
};
